import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { APP_URL, LOGO_URL, CONTACT } from "@/i18n/translations";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative z-10 border-t border-white/10 bg-[#050505]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt="Aportta" className="h-8 w-auto mb-6" />
            <p className="text-white/55 max-w-xs text-sm leading-relaxed">{t.footer.tagline}</p>
            <a
              href={APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-2 mt-8 text-[#FF3B30] font-bold"
            >
              {t.nav.cta}
              <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-widest text-white/40 mb-5">{t.footer.company}</p>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">{t.nav.services}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs tracking-widest text-white/40 mb-5">{t.footer.product}</p>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors">{CONTACT.email}</a></li>
              <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors">{CONTACT.phone}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">© {new Date().getFullYear()} Aportta. {t.footer.rights}</p>
          <p className="text-white/30 text-xs tracking-widest font-display">APORTTA · LOJİSTİK365</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
